import { useCurrentLanguage } from 'utils/hooks/useCurrentLanguage';

const useFoodFieldsEnabled = (): boolean => {
  const lang = useCurrentLanguage();

  return !lang.endsWith('_CH');
};

export default useFoodFieldsEnabled;
